export const reactSelectStyle = {
  control: {
    outline: '1px solid var(--color-semantic-outline)',
    border: 'none',
    borderRadius: '4px',
    boxShadow: 'none',
    boxSizing: 'border-box',
    fontSize: 'var(--font-body2)',
    minHeight: '34px',
    paddingLeft: '2px',
    cursor: 'pointer',
    zIndex: 1,
  },
  indicatorSeparator: {
    display: 'none',
  },
  menu: {
    borderRadius: '0px',
    zIndex: 2,
  },
  menuList: {
    padding: '0px',
    borderRadius: '0px',
    maxHeight: '200px',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
  },
  multiValue: {
    display: 'none',
  },
  placeholder: {
    color: 'var(--color-neutral40)',
  },
  singleValue: {
    color: 'var(--color-semantic-text)',
    fontSize: 'var(--font-body2)',
    maxWidth: '108px',
  },
  noOptionsMessage: {
    fontSize: 'var(--font-body2) !important',
    color: 'var(--color-neutral40) !important',
  },
};
